// extracted by mini-css-extract-plugin
export var showMoreIcon = "styles-module--showMore-icon--cacfb";
export var showMoreText = "styles-module--showMore-text--a7aab";
export var showMoreWrapper = "styles-module--showMore-wrapper--a60e5";
export var suptitle = "styles-module--suptitle--2f97d";